var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCovidClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.933 21.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#ff4500",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#ff4500",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.5291667,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "M9.26 281.125a.798.798 0 0 0-.793.794c0 .342.223.634.529.744v1.14a4.317 4.317 0 0 0-.84-.02.796.796 0 0 0-.748-.541.798.798 0 0 0-.793.794c0 .037.006.074.011.11a4.753 4.753 0 0 0-.729.386l-.95-.95a.779.779 0 0 0 .08-.34.798.798 0 0 0-.794-.794.798.798 0 0 0-.793.794c0 .435.358.793.793.794.122 0 .236-.03.34-.08l.891.89a4.812 4.812 0 0 0-.613.6.778.778 0 0 0-.353-.088.798.798 0 0 0-.794.794c0 .264.133.498.333.642-.086.22-.156.447-.21.681h-1.23a.796.796 0 0 0-.745-.53.798.798 0 0 0-.794.795c0 .435.359.793.794.793a.796.796 0 0 0 .744-.529h1.14a4.329 4.329 0 0 0-.02.84.796.796 0 0 0-.541.748c0 .435.359.793.794.793.038 0 .074-.006.11-.01.083.194.178.382.285.563l-1.115 1.115a.78.78 0 0 0-.339-.08.798.798 0 0 0-.793.794c0 .435.358.793.793.793a.798.798 0 0 0 .794-.793.78.78 0 0 0-.08-.339l1.04-1.04c.21.279.45.534.716.76a.778.778 0 0 0-.088.354c0 .435.358.794.793.794a.794.794 0 0 0 .643-.333c.22.086.446.156.68.21v1.23a.796.796 0 0 0-.529.745c0 .435.359.794.794.794a.798.798 0 0 0 .794-.794.796.796 0 0 0-.53-.744v-1.14a4.317 4.317 0 0 0 .84.02c.107.312.402.54.748.54a.798.798 0 0 0 .794-.793c0-.038-.006-.074-.012-.11.255-.108.499-.237.729-.386l.95.95a.782.782 0 0 0-.079.34c0 .435.358.794.793.794.435 0 .793-.36.793-.795a.796.796 0 0 0-.793-.793.78.78 0 0 0-.34.08l-.89-.891c.221-.181.426-.382.612-.6a.778.778 0 0 0 .353.088.798.798 0 0 0 .794-.793.794.794 0 0 0-.333-.643c.086-.22.157-.446.21-.68h1.231c.11.306.402.529.744.529a.798.798 0 0 0 .794-.794.798.798 0 0 0-.794-.794.796.796 0 0 0-.744.53h-1.14c.02-.175.032-.35.032-.53 0-.016 0-.032-.002-.049a.796.796 0 0 0 .53-.744.798.798 0 0 0-.793-.794h-.013a4.74 4.74 0 0 0-.381-.818l1.114-1.114a.78.78 0 0 0 .338.08.798.798 0 0 0 .794-.794.798.798 0 0 0-.794-.794.798.798 0 0 0-.793.794c0 .121.03.235.08.338l-1.042 1.042a4.804 4.804 0 0 0-.714-.761.78.78 0 0 0 .088-.354.798.798 0 0 0-.794-.794.794.794 0 0 0-.642.333 4.724 4.724 0 0 0-.68-.21v-1.231a.796.796 0 0 0 .529-.744.798.798 0 0 0-.794-.794zm-2.38 4.233a.265.265 0 1 1 0 .53.265.265 0 0 1 0-.53zm2.91.265c.435 0 .793.358.793.794a.798.798 0 0 1-.793.793.798.798 0 0 1-.794-.793c0-.436.358-.794.794-.794zm-1.853.265a.265.265 0 1 1 0 .529.265.265 0 0 1 0-.53zm1.853.264a.26.26 0 0 0-.265.265c0 .149.115.264.265.264a.26.26 0 0 0 .264-.264.26.26 0 0 0-.264-.265zm-3.175.53c.435 0 .793.358.793.793a.798.798 0 0 1-.793.794.798.798 0 0 1-.794-.794c0-.435.358-.794.794-.794zm4.762.264a.265.265 0 1 1 0 .529.265.265 0 0 1 0-.53zm-4.762.264a.26.26 0 0 0-.265.265c0 .15.115.265.265.265a.26.26 0 0 0 .264-.265.26.26 0 0 0-.264-.265zm1.852.265a.265.265 0 1 1 0 .53.265.265 0 0 1 0-.53zm2.38.53c.436 0 .795.358.795.793a.798.798 0 0 1-.794.794.798.798 0 0 1-.794-.794c0-.435.359-.794.794-.794zm-5.555.264a.265.265 0 1 1 0 .529.265.265 0 0 1 0-.53zm2.645.264a.265.265 0 1 1 0 .53.265.265 0 0 1 0-.53zm2.91 0a.26.26 0 0 0-.264.265c0 .15.116.265.265.265a.26.26 0 0 0 .264-.265.26.26 0 0 0-.264-.265zm-4.232.53a.265.265 0 1 1 0 .529.265.265 0 0 1 0-.53zm2.38 0a.265.265 0 1 1 0 .529.265.265 0 0 1 0-.53zm-3.174 1.058a.265.265 0 1 1 0 .529.265.265 0 0 1 0-.53zm1.852 0c.435 0 .794.358.794.794a.798.798 0 0 1-.794.793.798.798 0 0 1-.794-.793c0-.436.359-.794.794-.794zm1.852 0a.265.265 0 1 1 0 .529.265.265 0 0 1 0-.53zm1.058 0a.265.265 0 1 1 0 .529.265.265 0 0 1 0-.53zm-2.91.529a.26.26 0 0 0-.265.265c0 .149.116.264.265.264a.26.26 0 0 0 .264-.264.26.26 0 0 0-.264-.265zm1.852.53a.265.265 0 1 1 0 .528.265.265 0 0 1 0-.529z",
    transform: "translate(0 -280.067)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidClosed);
export default __webpack_public_path__ + "static/media/covid_closed.cf3e69e766c0672433a06b118b9ff0cc.svg";
export { ForwardRef as ReactComponent };